import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import PortalsBlockData from '../../../Models/Content/PortalsBlockData';
import Portal from './Portal';

export default class PortalBlock extends EpiComponent<PortalsBlockData> {
  constructor(props) {
    super(props);
  }

  public render(): ReactNode | ReactNodeArray | null {
    return <Portal context={this.getContext()} iContent={this.props.data} />;
  }
}
